import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Activate or deactivate a SPOC user.
 * DELETE api/SpocCreation/active-inactive-spoc?userId={userId}&isActive={true|false}
 *
 * @param {number|string} userId  - SPOC user ID
 * @param {boolean}       isActive - true = activate, false = deactivate
 */
export const toggleSpocStatusAction = async (userId, isActive) => {
  const id = Number(userId) || 0;
  const activeFlag = Boolean(isActive);

  // console.log(
  //   `[toggleSpocStatus] → DELETE active-inactive-spoc | userId=${id} | isActive=${activeFlag}`,
  // );

  try {
    const url = `${ATP_API_URL.SPOC_ACTIVE_INACTIVE}?userId=${id}&isActive=${activeFlag}`;
    const response = await apiClient.delete(url);

    console.log(
      "[toggleSpocStatus] ← response:",
      response?.status,
      response?.data,
    );

    if (response?.status === 200) {
      if (response.data?.success === false) {
        console.warn(
          "[toggleSpocStatus] API returned success=false:",
          response.data.message,
        );
        return {
          success: false,
          message: response.data.message || "Failed to update SPOC status",
        };
      }
      return {
        success: true,
        message:
          response.data?.message ||
          `SPOC ${activeFlag ? "activated" : "deactivated"} successfully`,
      };
    }

    console.error("[toggleSpocStatus] Unexpected status:", response?.status);
    return { success: false, message: "Failed to update SPOC status" };
  } catch (error) {
    console.error(
      "[toggleSpocStatus] Error:",
      error?.response?.data || error.message,
    );
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error.message ||
        "Failed to update SPOC status",
    };
  }
};
